<template>
  <b-card>
    <h2>Dispatch History</h2>
    <base-overlay :show="fetching">
      <b-table
        striped
        selectable
        :items="dispatches"
        :fields="tableColumns"
        show-empty
        empty-text="No dispatches found"
        @row-selected="navigateToTripDetails($event[0].trip_id)"
      />
    </base-overlay>
  </b-card>
</template>

<script>
import { ref } from '@vue/composition-api'
import { BCard, BTable } from 'bootstrap-vue'
import formatDate from '@/utils/date-format'

export default {
  components: { BCard, BTable },
  setup(props, ctx) {
    const tableColumns = [
      { label: 'trip id', key: 'trip_id' },
      { label: 'Date & Time', key: 'created_at', formatter: val => formatDate(val) },
    ]
    const dispatches = ref([])
    const fetching = ref(false)
    const getCanceledDispatch = async () => {
      try {
        fetching.value = true
        const result = await ctx.root.$store.dispatch('driverView/getCanceledDispatch', ctx.root.$route.query.externalId)
        dispatches.value = result.data.data
      } catch (error) {
        console.log(error)
      } finally {
        fetching.value = false
      }
    }
    const navigateToTripDetails = id => window.open(`${window.location.origin}/trips/${id}`)
    getCanceledDispatch()
    return {
      fetching,
      tableColumns,
      navigateToTripDetails,
      dispatches,
    }
  },
}
</script>

<style>

</style>
